import React from 'react';
import { Icon, TooltipWrapper } from '@tcc/crate';

import { getMessage } from 'util/locale';
import { inferUnit } from 'util/unitConversion';
import { formatNumberK } from 'util/formatters/numberFormatter';

const baseString = 'average-field-graph-label';

const FieldAverageGraphLabel = ({ fvssPlantingRate }: { fvssPlantingRate: number }) => {
  return (
    <section className={baseString}>
      <div>
        <p>
          {getMessage('text__fieldview-seed-scripts')}: {formatNumberK(fvssPlantingRate)}
        </p>
        <TooltipWrapper
          content={[getMessage('tooltip-text__scenarios-table')]}
          placement='top'
          className={`${baseString}__tooltip`}
        >
          <Icon glyph={Icon.set.INFO_CIRCLE} />
        </TooltipWrapper>
      </div>
      <p>{getMessage('planting-rate', { seedDensityUnit: inferUnit('seed-density').symbol.quantitySpecific })}</p>
    </section>
  );
};

export default FieldAverageGraphLabel;
